import loadable from '@loadable/component';

const CobntactUsLoadable = loadable(
  () => import(/* webpackChunkName: 'contact-us' */ './ContactUs')
);

const CobntactUs = () => <CobntactUsLoadable />;

export default CobntactUs;
